import { isApiFetchError } from '@borradh-workspace/api-client';

import { logError, logExpectedError } from '@/lib/log-error';

export function reportDeleteEventFailure(error: unknown): void {
  const report =
    isApiFetchError(error) && error.status === 409
      ? logExpectedError
      : logError;
  report('calendar.deleteEvent', error, { feature: 'appointments' });
}
